<mat-list class="list">
  <mat-list-item>
    <button
      matListItemTitle
      mat-button
      class="action"
      (click)="toggleDarkMode()"
      aria-label="Toggle Dark Theme"
      >
      <mat-icon matListIcon class="setting-icon" color="accent">{{
        isDarkMode ? 'dark_mode' : 'light_mode'
      }}</mat-icon>
    </button>
  </mat-list-item>
  @if (photoUrl) {
    <mat-list-item fxHide.lt-md class="user-avatar-item">
      <img [src]="photoUrl" class="user-avatar setting-icon" />
    </mat-list-item>
  }
  <mat-list-item>
    @if (isLoggedIn) {
      <button
        (click)="logOut()"
        class="action"
        mat-button
        aria-label="Logout"
        >
        <mat-icon
          class="nav-icon setting-icon"
          svgIcon="exit"
          aria-label="Logout"
        ></mat-icon>
      </button>
    }
  </mat-list-item>
</mat-list>
